var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wheel-game-color-tabs tabs" }, [
    _c(
      "div",
      {
        staticClass: "tabs__button tabs__button_blue",
        class: { "is-active": _vm.currentColor === _vm.Multiplier.X2 },
        on: {
          click: function ($event) {
            return _vm.changeColor(_vm.Multiplier.X2)
          },
        },
      },
      [_c("span", [_vm._v(_vm._s(_vm.formatCurrency(_vm.x2TotalBank)))])]
    ),
    _c(
      "div",
      {
        staticClass: "tabs__button tabs__button_green",
        class: { "is-active": _vm.currentColor === _vm.Multiplier.X3 },
        on: {
          click: function ($event) {
            return _vm.changeColor(_vm.Multiplier.X3)
          },
        },
      },
      [_c("span", [_vm._v(_vm._s(_vm.formatCurrency(_vm.x3TotalBank)))])]
    ),
    _c(
      "div",
      {
        staticClass: "tabs__button tabs__button_purple",
        class: { "is-active": _vm.currentColor === _vm.Multiplier.X4 },
        on: {
          click: function ($event) {
            return _vm.changeColor(_vm.Multiplier.X4)
          },
        },
      },
      [_c("span", [_vm._v(_vm._s(_vm.formatCurrency(_vm.x4TotalBank)))])]
    ),
    _c(
      "div",
      {
        staticClass: "tabs__button tabs__button_yellow",
        class: { "is-active": _vm.currentColor === _vm.Multiplier.X35 },
        on: {
          click: function ($event) {
            return _vm.changeColor(_vm.Multiplier.X35)
          },
        },
      },
      [_c("span", [_vm._v(_vm._s(_vm.formatCurrency(_vm.x35TotalBank)))])]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }